import { useState } from 'react';
import { formatDate } from '../../../../../utils/common/date';
import { Calendar } from '../../../Calendar';
import { CalendarIcon } from '../../../Icons';
import { Popover, PopoverContent, PopoverTrigger } from './Popover';
import styles from './styles.module.scss';

type Props = {
  value: Date | undefined;
  disabled?: boolean;
  fromDate?: Date;
  toDate?: Date;
  onChange?: (date: Date | undefined) => void;
  onBlur?: () => void;
};

export const DatePicker: React.FC<Props> = ({
  value,
  disabled,
  fromDate,
  toDate,
  onChange,
  onBlur,
}) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState<Date | undefined>(value);

  const handleChange = (date: Date | undefined) => {
    setOpen(false);
    setDate(date);
    onChange?.(date);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type='button'
          className={styles.datePickerTrigger}
          disabled={disabled}
          onBlur={onBlur}
        >
          <span className={styles.datePickerTriggerText}>
            {date ? formatDate({ date, formatType: 'yyyy年M月d日' }) : '年/月/日'}
          </span>
          <CalendarIcon size='sm' aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent align='start' className={styles.popoverContent}>
        <Calendar
          selected={date}
          onSelect={handleChange}
          captionLayout='label'
          fromDate={fromDate}
          toDate={toDate}
        />
      </PopoverContent>
    </Popover>
  );
};
